import Button from '@uds/button';
import Glyph from '@uds/glyphs';
import { useDSTContext } from 'presentation/components/pages/CMPage/DSTContext';
import { Message } from '@uds/message';
import { dispatchGAEvent } from '@uds/tagmg';
import { useUrls } from '@ux/whitelabel';

type Props = {
  basketCount: number;
  block: boolean;
};

const dispatchClickEvent = () => {
  dispatchGAEvent({
    hitType: 'event',
    eventCategory: 'Basket',
    eventAction: 'click',
    eventLabel: 'domains_sticky_checkout_btn',
  });
};

export default function CheckoutButton({ basketCount, block }: Readonly<Props>): JSX.Element {
  const { disableCtaButtons } = useDSTContext();
  const { basket: basketURL } = useUrls();
  return (
    <Button
      href={basketURL}
      onClick={dispatchClickEvent}
      block={block}
      disabled={disableCtaButtons}
      glyph={<Glyph name="cart" />}
    >
      <Message id="dst.v2.domain.search.input.sticky.checkout.button" values={{ count: basketCount }} />
    </Button>
  );
}
